export default "__VITE_ASSET__DR3Fh8Iu__"